import React, { useContext, useState } from 'react'
import { LocaleContext } from '../../routes'
import { LabelExtra } from '../../styles/elements'
import { GiftHint } from '../../styles/gift'
import Image from '../../styles/image'
import { getPersianNumber } from '../../utils/number'
import BottomSheetHint from '../common/BottomSheetHint'
import { getTransactionId, purchase } from '../../api'

export default ({
  setPaidGift,
  hideConfirmHint, showBoughtHint, showErrorNotification,
  title, icon, summary, price, id,
}) => {
  const [loading, setLoading] = useState()
  const locale = useContext(LocaleContext)

  const buyGift = async () => {
    setLoading(true)
    const transaction = await getTransactionId(id)
    const purchasedGift = transaction && transaction.transactionId &&
      await purchase(transaction.transactionId)
    setLoading(false)

    purchasedGift && showBoughtHint()
    !purchasedGift && showErrorNotification()
    hideConfirmHint()

    purchasedGift &&
      setPaidGift({ purchaseDate: purchasedGift.purchaseDate, isPaid: true })
  }

  const Title = props => <LabelExtra {...props} bold fontSize="16px" padding="16px" color="black" />
  const Summary = props => <LabelExtra {...props} bold color="black" />
  const Description = props => <LabelExtra {...props} align="center" padding="16px 0" />

  return (
    <BottomSheetHint
      cancel={hideConfirmHint}
      cancelText="back"
      submit={buyGift}
      submitText="yes"
      loading={loading}
    >
      <GiftHint>
        <Image alt={title} src={icon} width="50px" filter="none" />
        <Title>{title}</Title>
        <Summary>{summary}</Summary>
        <Description align="center" padding="15px">
          {locale.BY_USING_THIS_PRODUCT}{locale.COMMA}
          <LabelExtra bold color="#333">{getPersianNumber(price)} </LabelExtra>
          {locale.SCORE_WILL_BE_SUBTRACTED}.&nbsp;
          {locale.ARE_YOU_SURE}
        </Description>
      </GiftHint>
    </BottomSheetHint>
  )
}
